/**
 * Template Import/Export GraphQL Operations
 *
 * Phase 3: Template import/export with validation
 * Backend: graphql_gateway/src/metadata_api/template_import_export.rs
 */

import { gql } from '@apollo/client';

// ============================================================================
// MUTATIONS
// ============================================================================

export const EXPORT_TEMPLATE = gql`
  mutation ExportTemplate($input: ExportTemplateInput!) {
    exportTemplate(input: $input) {
      exportVersion
      template
      metadata {
        exportedAt
        exportedBy
        sourceTenant
        templateVersion
        checksum
      }
      evidence
    }
  }
`;

export const IMPORT_TEMPLATE = gql`
  mutation ImportTemplate($input: ImportTemplateInput!) {
    importTemplate(input: $input) {
      success
      templateId
      templateVersion
      tenantId
      warnings
      errorMessage
    }
  }
`;

export const VALIDATE_TEMPLATE_IMPORT = gql`
  mutation ValidateTemplateImport($input: ValidateTemplateInput!) {
    validateTemplateImport(input: $input) {
      valid
      errors
      warnings
      templateName
      templateVersion
    }
  }
`;

// ============================================================================
// TYPES
// ============================================================================

export interface ExportMetadata {
  exportedAt: string;
  exportedBy: string;
  sourceTenant: string;
  templateVersion: string;
  checksum: string;
}

export interface TemplateExportData {
  exportVersion: string;
  template: unknown; // Complete template JSON
  metadata: ExportMetadata;
  evidence: unknown | null;
}

export interface ImportResult {
  success: boolean;
  templateId: string;
  templateVersion: string;
  tenantId: string;
  warnings: string[];
  errorMessage: string | null;
}

export interface ValidationResult {
  valid: boolean;
  errors: string[];
  warnings: string[];
  templateName: string | null;
  templateVersion: string | null;
}

export interface ExportTemplateInput {
  templateId: string;
  tenantId: string;
  version: string | null;
  includeMetadata: boolean;
  includeEvidence: boolean;
}

export interface ImportTemplateInput {
  tenantId: string;
  templateData: unknown; // JSON object
  overwriteExisting: boolean;
  preserveIds: boolean;
}

export interface ValidateTemplateInput {
  templateData: unknown; // JSON object
}

// ============================================================================
// QUERY/MUTATION VARIABLES
// ============================================================================

export interface ExportTemplateVariables {
  input: ExportTemplateInput;
}

export interface ImportTemplateVariables {
  input: ImportTemplateInput;
}

export interface ValidateTemplateImportVariables {
  input: ValidateTemplateInput;
}
